
















































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';

import DeleteParam from '@/models/account/DeleteParam';
import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class DeleteConfirm extends BaseView {
  private deleteParam = new DeleteParam();

  private message = '';

  private isIndicatorDisplay = false;

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * ログイン中アカウントの削除を行います。
   * 削除が成功した場合、保持しているJWTを削除し完了画面へ遷移します。
   */
  async accountDelete() {
    this.message = '';

    if (StringUtil.isEmpty(this.deleteParam.password)) {
      this.message = 'パスワードを入力してください';
      return;
    }

    this.isIndicatorDisplay = true;
    const AccountRepo = RepositoryFactory.get().account;
    await AccountRepo.deleteAccount(this.deleteParam)
      .then(() => {
        JwtUtil.deleteJwt();
        this.$router.replace(this.paths.DELETE_COMPLETE);
      })
      .catch((err) => {
        // TODO: API側がパスワードチェック処理未実装のため後日確認する
        if (err.response.data && err.response.data.error) {
          this.message = err.response.data.error;
          return;
        }
        this.message = 'アカウント削除処理に失敗しました';
      });
    this.isIndicatorDisplay = false;
  }
}
